import React from "react";
import { useCoreApp } from "@/contexts/CoreAppContext";
import { useZoom } from "@/contexts/ZoomContext";
import { twClassNames } from "@scripts/react/helpers/twClassNames";
import { DropdownMenu } from "@/components/DropdownMenu";
import { AnnotationLabelsToggle } from "@/components/flow/build/AnnotationLabelsToggle";
import { ZoomControls } from "@/components/flow/build/ZoomControls";

interface AnnotationControlsProps {
    className?: string;
}

type ControlOption = {
    id: string;
    label: string;
    action: () => void;
    isSelected?: boolean;
    icon: string;
};

export const AnnotationControls: React.FC<AnnotationControlsProps> = ({ className = "" }) => {
    const { showLabels, setShowLabels } = useCoreApp();
    const { resetZoom, zoomIn, zoomOut } = useZoom();

    /* Dropdown menu options */
    const options: ControlOption[] = [
        { id: "zoom-in", label: "Zoom In", action: zoomIn, icon: "fas fa-plus" },
        { id: "zoom-out", label: "Zoom Out", action: zoomOut, icon: "fas fa-minus" },
        { id: "reset-zoom", label: "Reset Zoom", action: resetZoom, icon: "fas fa-undo" },
        {
            id: "labels",
            label: showLabels ? "Labels Shown" : "Labels Hidden",
            action: () => setShowLabels(!showLabels),
            icon: showLabels ? "fas fa-eye" : "fas fa-eye-slash"
        }
    ];

    return (
        <>
            <div
                className={twClassNames("hidden items-center justify-end gap-2 lg:flex", className)}
            >
                <AnnotationLabelsToggle showLabels={showLabels} onToggle={setShowLabels} />
                <div className="h-6 w-px flex-shrink-0 bg-divider" />
                <ZoomControls />
            </div>

            <div className={twClassNames("flex items-center justify-end lg:hidden", className)}>
                <DropdownMenu
                    items={options}
                    selectedItem={options[0]}
                    onSelectItem={(item) => item.action()}
                    getItemLabel={(item) => item.label}
                    getLeftContent={(item) => <i className={`${item.icon} fa-fw`} />}
                    getItemKey={(item) => item.id}
                    buttonClassName="btn2 ghost xsmall square"
                    customMenuButton={<i className="fas fa-cog"></i>}
                    menuItemsClassName="!w-36 right-0 mt-1"
                    stayOpenAfterSelection={true}
                />
            </div>
        </>
    );
};
